import React from 'react';
import { TrendingUp, Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const navigate = useNavigate();

    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Company Info */}
                    <div className="space-y-4">
                        <div className="flex items-center space-x-2">
                            <div className="bg-white p-2 rounded-lg">
                                <img className="h-6 w-6" src='/logo.png' />
                            </div>
                            <span className="text-xl font-bold">Saisamriddhi</span>
                        </div>
                        <p className="text-gray-400 leading-relaxed">
                            Your trusted partner in building a secure financial future.
                            We provide comprehensive financial solutions tailored to your unique needs.
                        </p>
                        <div className="flex space-x-4">
                            <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-200">
                                <Facebook className="h-5 w-5" />
                            </a>
                            <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-200">
                                <Twitter className="h-5 w-5" />
                            </a>
                            <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-200">
                                <Linkedin className="h-5 w-5" />
                            </a>
                            <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-200">
                                <Instagram className="h-5 w-5" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-white transition-colors duration-200">
                                    Home
                                </button>
                            </li>
                            <li>
                                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white transition-colors duration-200">
                                    About Us
                                </button>
                            </li>
                            <li>
                                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-white transition-colors duration-200">
                                    Services
                                </button>
                            </li>
                            <li>
                                <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-white transition-colors duration-200">
                                    Gallery
                                </button>
                            </li>
                            <li>
                                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-white transition-colors duration-200">
                                    Contact
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Our Services</h3>
                        <ul className="space-y-2">
                            <li className="text-gray-400">Investment Planning</li>
                            <li className="text-gray-400">Insurance Solutions</li>
                            <li className="text-gray-400">Retirement Planning</li>
                            <li className="text-gray-400">Tax Planning</li>
                            <li className="text-gray-400">Wealth Management</li>
                            <li className="text-gray-400">Corporate Advisory</li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
                        <div className="space-y-3">
                            <div className="flex items-start space-x-3">
                                <Phone className="h-5 w-5 text-blue-400 mt-0.5" />
                                <div>
                                    <p className="text-gray-400">+91 97720 41041</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Mail className="h-5 w-5 text-blue-400 mt-0.5" />
                                <div>
                                    <p className="text-gray-400">ssmicro.ho@gmail.com</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <MapPin className="h-5 w-5 text-blue-400 mt-0.5" />
                                <div>
                                    <p className="text-gray-400">59 Brijpuri Near 7 no. Bus Stand</p>
                                    <p className="text-gray-400">Airport Road Jagatpura, Jaipur</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-400 text-sm">
                        © 2024 Saisamriddhi. All rights reserved.
                    </p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <p onClick={() => navigate('/privacy-policy')} className="cursor-pointer text-gray-400 hover:text-white text-sm transition-colors duration-200">
                            Privacy Policy
                        </p>
                        <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
                            Terms of Service
                        </a>
                        <a href="./panCard.pdf" target='_blank' className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
                            Pan Card
                        </a>
                        <a href="./regCertificate.pdf" target='_blank' className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
                            Registration Certificate
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;